import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
import cx from 'classnames';
import FormikTextFieldWithClearError from 'components/FormikFields/FormikTextFieldWithClearError';
import FormikSelectFieldWithClearError from 'components/FormikFields/FormikSelectFieldWithClearError';
import RoundedButton from 'components/Shared/RoundedButton';
import { STATES } from 'components/Accounts/constants';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  addressContainer: {
    width: '100%',
    maxWidth: 1400,
  },
  removeBtn: {
    margin: theme.spacing(1.5, 1.5, 3, 0),
  },
  fullWidth: {
    width: '100%',
  },
  statesSelect: {
    marginTop: theme.spacing(1),
  },
  ml2: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(1.5),
    },
  },
}));

const AddressForm = ({
                       prefix,
                       backendErrors,
                       disabled,
                       onRemove,
                       fullWidth,
                       hasMobileLayout,
                       clearBackendError,
                     }) => {
  const { en: { forms } } = useSelector((state) => state.i18n);
  const classes = useStyles();
  // const name = prefix ? `${prefix}.name` : 'name';
  const streetAddress = prefix ? `${prefix}.streetAddress` : 'streetAddress';
  const suite = prefix ? `${prefix}.suite` : 'suite';
  const city = prefix ? `${prefix}.city` : 'city';
  const state = prefix ? `${prefix}.state` : 'state';
  const zipCode = prefix ? `${prefix}.zipCode` : 'zipCode';

  return (
    <>
      <Grid
        container
        spacing={3}
        m={0}
        className={cx({
          [classes.ml2]: hasMobileLayout,
          [classes.addressContainer]: !fullWidth,
        })}
      >
        <Grid item xs={12} sm={8} md={8} lg={8}>
          <FormikTextFieldWithClearError
            type='text'
            name={streetAddress}
            label={forms.streetAddress}
            backendError={backendErrors[streetAddress]}
            // fullWidth={fullWidth}
            disabled={disabled}
            required
            clearBackendError={clearBackendError}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={4}>
          <FormikTextFieldWithClearError
            type='text'
            name={suite}
            label={forms.suite}
            backendError={backendErrors[suite]}
            disabled={disabled}
            clearBackendError={clearBackendError}
          />
        </Grid>
      </Grid>

      <Grid
        container
        wrap='wrap'
        justify='space-between'
        alignItems='flex-start'
        className={classes.fullWidth}
      >
        <Grid
          container
          m={0}
          spacing={3}
          className={fullWidth ? undefined : classes.addressContainer}
        >
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <FormikTextFieldWithClearError
              type='text'
              name={city}
              label={forms.city}
              backendError={backendErrors[city]}
              disabled={disabled}
              required
              clearBackendError={clearBackendError}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2} lg={2}>
            <FormikSelectFieldWithClearError
              name={state}
              label={forms.state}
              type='text'
              menuItems={STATES}
              className={cx(classes.statesSelect, classes.fullWidth)}
              backendError={backendErrors[state]}
              disabled={disabled}
              required
              clearBackendError={clearBackendError}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2} lg={2}>
            <FormikTextFieldWithClearError
              type='text'
              name={zipCode}
              label={forms.zipCode}
              backendError={backendErrors[zipCode]}
              disabled={disabled}
              required
              clearBackendError={clearBackendError}
            />
          </Grid>
        </Grid>

        {onRemove && (
          <RoundedButton
            variant='contained'
            color='secondary'
            size='small'
            onClick={onRemove}
            className={classes.removeBtn}
          >
            {forms.removeAddress}
          </RoundedButton>
        )}
      </Grid>
    </>
  );
};

AddressForm.propTypes = {
  prefix: PropTypes.string,
  backendErrors: PropTypes.shape({
    name: PropTypes.string,
    streetAddress: PropTypes.string,
    suite: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zipCode: PropTypes.string,
  }),
  fullWidth: PropTypes.bool,
  clearBackendError: PropTypes.func,
  disabled: PropTypes.bool,
  hasMobileLayout: PropTypes.bool,
  onRemove: PropTypes.func,
};

AddressForm.defaultProps = {
  prefix: '',
  fullWidth: false,
  backendErrors: {},
  disabled: false,
  onRemove: undefined,
  hasMobileLayout: false,
};

export default AddressForm;
